import { elements } from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { ownerDocument } = button
    const targetValue = one(`.${utilities.modifiers.lightbox.open}`, ownerDocument)

    if (button.classList.contains(elements.click_to_copy_button)) {
      targetValue.focus()
    }
  }
})

export default (
  dropdown
) => {
  const buttonClickToCopy = one(`.${elements.click_to_copy_button}`, dropdown)

  if (buttonClickToCopy) {
    onClick.listen(buttonClickToCopy)
  }
}
